import { render } from "./TestEndProgress.vue?vue&type=template&id=faf12b12&scoped=true&ts=true"
import script from "./TestEndProgress.vue?vue&type=script&lang=ts"
export * from "./TestEndProgress.vue?vue&type=script&lang=ts"

import "./TestEndProgress.vue?vue&type=style&index=0&id=faf12b12&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faf12b12"]])

export default __exports__